export const MAX_PNG_BYTES = 500 * 1024;

export const validatePngFile = (file) => {
  if (!file) {
    return null;
  }
  if (file.type !== "image/png") {
    return "Only PNG files are allowed";
  }
  if (file.size > MAX_PNG_BYTES) {
    return "Max file size is 500KB";
  }
  return null;
};

export const normalizeFieldErrors = (errs) => {
  if (!errs || typeof errs !== "object" || Array.isArray(errs)) {
    return {};
  }
  const normalized = {};
  for (const [key, value] of Object.entries(errs)) {
    if (typeof value === "string") {
      normalized[key] = value;
      continue;
    }
    if (value === null || value === undefined) {
      normalized[key] = "";
      continue;
    }
    if (typeof value === "object") {
      normalized[key] = JSON.stringify(value);
      continue;
    }
    normalized[key] = String(value);
  }
  return normalized;
};
